// @flow
import { fetchPage as apiFetchPublicPage } from 'api/website';
import type { Page } from 'api/cms';
import type { Dispatch, GetState } from '..';
import { setError } from './error';

type FetchPageRequestAction = {
  type: 'FETCH_PAGE_REQUEST',
  url: string
};
type FetchPageSuccessAction = {
  type: 'FETCH_PAGE_SUCCESS',
  page: Page,
  url: string
};
type FetchPageFailureAction = {
  type: 'FETCH_PAGE_FAILURE',
  url: string
};

export type Action =
  | FetchPageRequestAction
  | FetchPageSuccessAction
  | FetchPageFailureAction;

const fetchPageRequest = (url: string): FetchPageRequestAction => ({
  type: 'FETCH_PAGE_REQUEST',
  url
});

const fetchPageSuccess = (page: Page, url: string): FetchPageSuccessAction => ({
  type: 'FETCH_PAGE_SUCCESS',
  page,
  url
});

const fetchPageFailure = (url: string): FetchPageFailureAction => ({
  type: 'FETCH_PAGE_FAILURE',
  url
});

export const fetchPage = (pageUrl: string) => (
  dispatch: Dispatch,
  getState: GetState
) => {
  const state = getState();
  const page = state.pages.byUrl[pageUrl];
  if (!page) {
    dispatch(fetchPageRequest(pageUrl));
    apiFetchPublicPage(pageUrl)
      .then(fetchedPage => {
        dispatch(fetchPageSuccess(fetchedPage, pageUrl));
      })
      .catch(e => {
        if (e.statusCode === 404) {
          dispatch(fetchPageFailure(pageUrl));
        } else {
          dispatch(setError(e));
        }
      });
  }
};

export const updatePage = fetchPageSuccess;
